export default {
  getGeneralInfo: ({ securitizeIdInvestor }) => securitizeIdInvestor,
  isDetailsEditableBlock: ({ editableBlock }) => blockName => editableBlock === blockName,
  getDetailsEditableBlock: ({ editableBlock }) => editableBlock,
  getLegalSignerByIdInfo: state => state.legalSignerByIdInfo,
};
